
import "./pako.js";
import "../kendo.core.js";
import "../kendo.color.js";
import "../kendo.drawing.js";
(function($) {

})(window.kendo.jQuery);